export function hasProductGalleryOnPage() {
    return !!globalThis?.document?.querySelector(
        '[data-element-type="dSnipcartProductGalleryId"]'
    );
}

const widgetSelectors = {
    menuSelectors: {
        wrapper: null,
        list: 'filter-sort-menu-list',
        divider: 'filter-sort-menu-divider',
        closeIcon: 'filter-sort-menu-closeIcon',
    },
    inputsSelectors: {
        slider: 'range-slider-',
        input: 'filterItem-input-icon-wrapper',
        inputIcon: 'input-icon',
        inputLabel: 'filterItem-input-label',
    },
    textSelectors: {
        displayName: 'filter-sort-menu-displayName',
        title: 'filter-sort-menu-item-title',
    },
};
export const menuSelectors = widgetSelectors.menuSelectors;
export const inputsSelectors = widgetSelectors.inputsSelectors;
export const textSelectors = widgetSelectors.textSelectors;

export function extractOptionId(fieldId: string): string {
    return fieldId.match(/^options\.choices_multi_select\[(.*)\]$/)?.[1] || '';
}

export function extractCustomFieldId(fieldId: string): string {
    return fieldId.match(/^custom_field\[(.*)\]$/)?.[1] || '';
}

export function createOneOfFiltersData(
    values: Array<string | number>
): Record<string, string | number> {
    const seen = new Set<string>();
    return values
        .filter((value) => {
            const normalized = String(value).toLowerCase();
            if (seen.has(normalized)) {
                return false;
            }
            seen.add(normalized);
            return true;
        })
        .sort((a, b) =>
            String(a).localeCompare(String(b), undefined, { numeric: true })
        )
        .reduce<Record<string, string | number>>((acc, value) => {
            acc[value] = value;
            return acc;
        }, {});
}
